<template>
  <search-group @search="findData" @clear="clearValue">
    <Row :gutter="24">
      <Col span="4">
        <Select placeholder="城市" v-model="searchData.cityCode">
          <Option value="">请选择</Option>
          <Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>

      <Col span="4">
        <Select placeholder="项目类型" v-model="searchData.projectTypeCode">
          <Option value="">请选择</Option>
          <Option v-for="item in projectTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select placeholder="项目状态" v-model="searchData.projectStatusCode">
          <Option value="">请选择</Option>
          <Option v-for="item in projectStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Input type="text" v-model="searchData.projectNameAndAddress" placeholder="项目名称或地址" @keyup.enter.native="findData"/>
      </Col>
    </Row>
  </search-group>
</template>

<script>
  import SearchGroup from 'components/SearchGroup/index';
  import {selectCondition} from "../../../../api/project";

  export default {
    name: "SearchList",
    components: {
      SearchGroup,
    },
    data() {
      return {
        cityList:[],
        projectTypeList:[],
        projectStatusList:[],

        searchData: {
          cityCode: '',
          projectTypeCode: '',
          projectStatusCode: '',
          projectNameAndAddress: '',
          page: 1,
          limit: 10,
        }
      }
    },
    methods: {
      findData() {
        this.$emit('findData', this.searchData)
      },
      clearValue() {
        this.searchData = {
          cityCode: '',
          projectTypeCode: '',
          projectStatusCode: '',
          projectNameAndAddress: '',
          page: 1,
          limit: 10,
        }
      }
    },
    created(){
      selectCondition().then(res=>{
        this.cityList=res.data.city
        this.projectTypeList=res.data.projectType
        this.projectStatusList=res.data.projectStatus
      })

    }
  }
</script>

<style scoped>

</style>
